import React from "react";

import "./AccreditationsDetails.css";
import { Link } from "react-router-dom";


const AccreditationsDetails = () => {
  return (

     
      <div 
        className="container accreditationsDetails-section"
        data-aos="fade-up"
        data-aos-delay="100">
        

        <div className="row">
          <div className="col-lg-12">
            <div className="title-box">
              <h2>A.I.C.T.E.</h2>
              <p className="mt-3">All India Council for Technical Education</p>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-lg-8">
            <div className="details-box">
              <h2>Mandatory Disclosure [AICTE]</h2>
              <ul>
                <li>
                  <Link href="#">
                    ENGINEERING AND TECHNOLOGY [B.E., M.E./M.Tech.] [Updated on
                    14.12.2024]
                  </Link>
                </li>
                <li>
                  <Link href="#">
                    Teaching Staff Details [Updated on 21.08.2024]
                  </Link>
                </li>
                <li>
                  <Link href="#">
                    NBA and NAAC Accreditation Status [Updated on 08.03.2025]
                  </Link>
                </li>
              </ul>
            </div>

            <div className="details-box">
              <h2>A.I.C.T.E. Approvals</h2>
              <ul>
                <li>
                  <Link href="#">
                    AICTE's Approval Letter 2025-2026 [Engineering Programmes]
                  </Link>
                </li>
                <li>
                  <Link href="#">
                    AICTE's Approval Letters - Engineering Programmes [1993 to
                    2025]
                  </Link>
                </li>
                <li>
                  <Link href="#">AICTE's Approval Letters - MCA Programme</Link>
                </li>
                <li>
                  <Link href="#">Document Retention Policy</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4">
             <div>
              <div className="sideNav-box">
                <h2>Navigation</h2>

                <ul>
                  <li>
                    <Link href="#">A.I.C.T.E.</Link>
                  </li>

                  <li>
                    <Link href="#">N.B.A.</Link>
                  </li>

                  <li>
                    <Link href="#">N.A.A.C.</Link>
                  </li>

                  <li>
                    <Link href="#">N.I.R.F.</Link>
                  </li>

                  <li>
                    <Link href="#">U.G.C.</Link>
                  </li>

                  <li>
                    <Link href="#">A.I.S.H.E.</Link>
                  </li>

                  <li>
                    <Link href="#">I.Q.A.C.</Link>
                  </li>
                </ul>
              </div>
            </div> 
            
          </div>
        </div>
      </div>

    
  );
};

export default AccreditationsDetails;
